import { render, staticRenderFns } from "./MarkingAttachmentComparison.vue?vue&type=template&id=605a7e86&scoped=true"
import script from "./MarkingAttachmentComparison.vue?vue&type=script&lang=js"
export * from "./MarkingAttachmentComparison.vue?vue&type=script&lang=js"
import style0 from "./MarkingAttachmentComparison.vue?vue&type=style&index=0&id=605a7e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a7e86",
  null
  
)

export default component.exports